import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LicenseInfo } from '@mui/x-license-pro';

import { checkAuthStatus } from './features/auth/authSlice'

import './App.css'
import './assets/css/variables.css'
import AppRouter from './components/AppRouter'
import LoadingSpinner from './components/UI/LoadingSpinner'
import CSnackbar from './components/UI/CSnackbar';

const App = () => {
    const dispatch = useDispatch()
    const { isAuthenticated, isCheckingAuth } = useSelector((state) => state.auth)

    useEffect(() => {
        dispatch(checkAuthStatus())
    }, [dispatch])

    // Initialize MUI license
    useEffect(() => {
        LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_DATAGRID_PRO_LICENSE_KEY);
    }, []);

    if (isCheckingAuth) {
        return (
            <div className="app-loading">
                <LoadingSpinner />
            </div>
        )
    }

    return (
        <>
            <CSnackbar />
            <AppRouter />
        </>
    )
}

export default App
